<template>
  <div class="home">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="accInfo">
        <div class="avatar">
          <img src="@/assets/images/home/login_logo.png">
        </div>
        <div class="information" :class="bankList.length == 0 ? 'noBank' : ''">
          <span>{{ cryptoMobilePhone }}</span>
          <p>{{ bankTxt }}</p>
        </div>
      </div>
      <div class="fundInfo">
        <div class="layout">
          <img class="pic" src="@/assets/images/home/pic.png">
          <div>
            <div class="balance" :class="asterisk == 0 ? 'checked' : ''">
              <span>我的余额（美元）</span>
              <p @click="clickAsterisk" />
            </div>
            <div class="money" :class="asterisk == 0 ? 'checked' : ''">
              <span>{{ asterisk == 0 ? "****" : balance }}</span>
            </div>
          </div>
          <div class="btn">
            <span
              v-sa="{
                ClickDeposit: {
                  PType:
                    pageType == 'app'
                      ? 'app端'
                      : pageType == 'trade'
                        ? 'H5交易'
                        : '用户中心',
                  AccountType: '真实账户',
                  entry: '个人中心-存款',
                },
              }"
              class="save"
              @click="goMoney('recharge')"
            >存款</span>
            <span
              v-sa="{
                ClickWithdrawals: {
                  PType:
                    pageType == 'app'
                      ? 'app端'
                      : pageType == 'trade'
                        ? 'H5交易'
                        : '用户中心',
                  AccountType: '真实账户',
                  entry: '个人中心-取款',
                },
              }"
              class="etch"
              @click="goMoney('withdrawal')"
            >提现</span>
          </div>
        </div>
      </div>
      <div class="dv_list">
        <ul>
          <!--v-if="isPersonalInfo"-->
          <li @click="goPersonalInfo">
            <img src="@/assets/images/home/user_grxx.png">
            <div class="item">
              <p>个人信息</p>
              <div class="add">
                <span v-if="isCertifyLoading" class="loading-spinner" />
                <em v-else>{{ status }}</em>
                <img src="@/assets/images/template/user_arrow.png">
              </div>
            </div>
          </li>
          <!-- 银行卡 -->
          <li
            v-sa="{
              binding_cards: {
                PType:
                  pageType == 'app'
                    ? 'app端'
                    : pageType == 'trade'
                      ? 'H5交易'
                      : '用户中心',
                AccountType: '真实账户',
                entry: '个人中心-银行卡列表',
              },
            }"
            @click="BankCardList"
          >
            <img src="@/assets/images/home/user_yhk.png">
            <div class="item">
              <p>银行卡</p>
              <div class="add">
                <span v-if="isBankLoading" class="loading-spinner" />
                <em v-else-if="isAddBank">未添加</em>
                <img src="@/assets/images/template/user_arrow.png">
              </div>
            </div>
          </li>

          <!-- 电子钱包 -->
          <li v-if="withdrawMethod.usdt" @click="goEwalletList">
            <img src="@/assets/images/home/user_ewallet.png">
            <div class="item">
              <p>电子钱包</p>
              <div class="add">
                <span v-if="isWalletLoading" class="loading-spinner" />
                <em v-else-if="isAddWallet">未添加</em>
                <img src="@/assets/images/template/user_arrow.png">
              </div>
            </div>
          </li>
          <!--<li><img src="@/assets/images/home/user_hdzx.png"/><div class="item"><p>活动中心</p><img src="@/assets/images/template/user_arrow.png"/></div></li>-->
          <li @click="goTickData">
            <img src="@/assets/images/home/user-fenbishuju.png">
            <div class="item">
              <p>历史分笔数据</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li @click="goReport">
            <img src="@/assets/images/home/user_jyjl.png">
            <div class="item">
              <p>交易记录</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li v-if="isEmergency" @click="goUrgentClose">
            <img src="@/assets/images/home/user_jjpc.png">
            <div class="item">
              <p>紧急平仓</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li @click="goMessageCenter">
            <img src="@/assets/images/home/user_xxzx.png">
            <div class="item">
              <p>消息中心</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <!--<li @click="goPaySettings"><img src="@/assets/images/home/user_zfsz.png"/><div class="item"><p>支付设置</p><img src="@/assets/images/template/user_arrow.png"/></div></li>-->
          <li @click="goModifyPwd">
            <img src="@/assets/images/home/user_aqsz.png">
            <div class="item">
              <p>密码管理</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li @click="goReferral">
            <img src="@/assets/images/home/referral_icon.png">
            <div class="item">
              <p>邀请好友</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li @click="goAboutUs">
            <img src="@/assets/images/home/user_gywm.png">
            <div class="item">
              <p>关于我们</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
          <li @click="goMT5LoginTutorial">
            <img src="@/assets/images/home/user_mt5.png">
            <div class="item">
              <p>MT5登入教学</p>
              <img src="@/assets/images/template/user_arrow.png">
            </div>
          </li>
        </ul>
      </div>
      <div class="signOut">
        <span
          v-sa="{
            Logout: {
              PType:
                pageType == 'app'
                  ? 'app端'
                  : pageType == 'trade'
                    ? 'H5交易'
                    : '用户中心',
              AccountType: '真实账户',
              is_success: 'true',
            },
          }"
          @click="deleteUser"
        >退出登录</span>
        <Chat />
      </div>
    </div>
    <!--存取款流程-->
    <DepositAndWithdrawal
      v-if="isDepositAndWithdrawal"
      :is-deposit-and-withdrawal="isDepositAndWithdrawal"
      :this-page-type="pageType"
      :source="source"
      :money-status="moneyStatus"
      @moneyStatue="moneyStatue"
    />
    <AlertPop
      :model="showAlertPop"
      :content="alertPopContent"
      :button1txt="alertPopCustomized.button1Txt"
      @alertOnClose="alertBoxClose"
    />
  </div>
</template>

<script>
require('@/assets/css/homepage.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import DepositAndWithdrawal from '@/view/module/DepositAndWithdrawal.vue'
import AlertPop from '@/view/module/AlertPop.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'Homepage',
  components: { Header, DepositAndWithdrawal, Chat, AlertPop },
  data() {
    return {
      title: '个人中心',
      isAsterisk: 0,
      isDepositAndWithdrawal: false,
      moneyStatus: '',
      balance: '',
      isCertifyLoading: true,
      status: '',
      bankList: '',
      isBankLoading: true,
      isWalletLoading: true,
      isAddBank: false,
      isAddWallet: true,
      walletList: [],
      bankTxt: '',
      source: 'home',
      rightContent: 'isNo',
      isPersonalInfo: false,
      isEmergency: false,
      isBankPop: false,
      activeStatus: false,
      showAlertPop: false,
      alertPopContent: '',
      alertPopCustomized: {
        button1Txt: ''
      },
      withdrawMethod: {
        usdt: false,
        bank: true
      }
    }
  },
  computed: {
    ...mapState([
      'user',
      'pageType',
      'asterisk',
      'gts2CustomerId',
      'accountInfo'
    ]),
    cryptoMobilePhone: function() {
      let mobilePhone = ''
      const float = this.user.mobilePhone.substr(0, 3)
      const end = this.user.mobilePhone.substr(8, 3)
      mobilePhone = float + '*****' + end
      return mobilePhone
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.certifyInfo()
    this.AccTradeInfo(this.gts2CustomerId)
    this.withdrawBankList()
    this.emergencyAuth()
    this.getWithdrawMethod()
    this.getWalletList() // Added API call here
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    clickAsterisk() {
      if (this.asterisk == 0) this.isAsterisk = 1
      if (this.asterisk == 1) this.isAsterisk = 0
      this.$store.dispatch('setAsterisk', this.isAsterisk)
    },
    withdrawBankList() {
      this.isBankLoading = true // Start loading
      const arrList = []

      api.getWithdrawBankList()
        .then((res) => {
          if (res.status && res.data.code === 200) {
            if (res.data.data.withdrawBankList) {
              const list = res.data.data.withdrawBankList

              // Only show "未添加" if the raw list is entirely empty
              this.isAddBank = list.length === 0

              for (const j in list) {
                if (list[j].approveStatus == 'APPROVAL') {
                  arrList.push(list[j])
                }
              }
              this.bankList = arrList

              if (this.bankList.length == 0) {
                this.bankTxt = '未绑定银行卡'
              } else {
                this.bankTxt = '已绑卡'
              }
            }
          }
        })
        .catch(() => {
          // Handle potential errors quietly or add your preferred logic
        })
        .finally(() => {
          this.isBankLoading = false // Stop loading regardless of success/fail
        })
    },

    getWalletList() {
      this.isWalletLoading = true // Start loading

      api.getWalletList()
        .then((res) => {
          if (res.data.code === 200) {
            this.walletList = res.data.data || []

            // Only show "未添加" if the wallet list is completely empty
            this.isAddWallet = this.walletList.length === 0
          }
        })
        .catch(() => {
          // Errors handled silently as requested
        })
        .finally(() => {
          this.isWalletLoading = false // Stop loading
          if (typeof this.appendCopyEvent === 'function') {
            this.appendCopyEvent()
          }
        })
    },
    goMoney(data) {
      this.isDepositAndWithdrawal = true
      this.moneyStatus = data
    },
    moneyStatue(data) {
      this.isDepositAndWithdrawal = data
    },
    goIdentity() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/identity' })
    },
    goPersonalInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/personalInfo' })
    },
    BankCardList() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      this.$router.push({ path: '/home/bankList' })
    },
    goEwalletList() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/eWalletList' })
    },
    goTickData() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/tickData' })
    },
    goReport() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      this.$router.push({ path: '/home/report' })
    },
    goUrgentClose() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      this.$router.push({ path: '/home/urgentClose' })
    },
    goMessageCenter() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 1)
      this.$router.push({ path: '/home/messageCenter' })
    },
    goPaySettings() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/paySettings' })
    },
    goModifyPwd() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/modifyPwd' })
    },
    goReferral() {
      if (!this.activeStatus) {
        this.showAlertPop = true
        this.alertPopContent = '阁下账户尚未激活<br>需激活后才能获取推荐链接'
        this.alertPopCustomized.button1Txt = '立即激活'
      } else {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/referral' })
      }
    },
    goMT5LoginTutorial() {
      window.location.href = process.env.VUE_APP_MT5_LOGIN_TUTORIAL
    },
    goAboutUs() {
      window.location.href = 'https://m.cfaa139.com/cn/aboutUS.html'
    },
    certifyInfo() {
      this.isCertifyLoading = true // Start loading

      api.getCertifyInfo()
        .then((res) => {
          if (res.status) {
            if (res.data.code == 200) {
              if (res.data.data) {
                this.status = '已完善'
              } else {
                this.status = '未完善'
              }
            }
          }
        })
        .catch(() => {
          // Fail silently or handle error if needed
        })
        .finally(() => {
          this.isCertifyLoading = false // Stop loading regardless of success/fail
        })
    },
    AccTradeInfo(data) {
      api.getAccTradeInfo(data).then((res) => {
        if (res.data.code == 200) {
          this.balance = res.data.data.accountSummary.totalMoney
          const status = res.data.data.accTradeInfoList[0].accountStatusName
          if (status == '已激活') this.activeStatus = true
        }
      })
    },
    emergencyAuth() {
      api.getEmergencyAuth().then((res) => {
        if (res.data.code == 200) {
          this.isEmergency = res.data.data.GTS2
        }
      })
    },
    deleteUser() {
      localStorage.clear()
      this.$store.dispatch('setUser', {})
      this.$store.dispatch('setTokenCookie', {})
      this.$router.go(0)
    },
    getWithdrawMethod() {
      if (this.accountInfo.cashoutTag) {
        const tag = this.accountInfo.cashoutTag
        if (tag === 'X1') {
          this.withdrawMethod.usdt = true
        } else if (tag === 'X2') {
          this.withdrawMethod.usdt = true
          this.withdrawMethod.bank = true
        }
      }
    },
    alertBoxClose() {
      this.showAlertPop = false
      this.alertPopContent = ''
      this.alertPopCustomized.button1Txt = ''
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/recharge' })
    }
  }
}
</script>
